import React from 'react';
import styles from './HeroSection.module.css';
import Button from '../../../../components/common/Button/Button';

/**
 * @component HeroCTAGroup
 * @description Hero CTA 버튼 그룹
 */
function HeroCTAGroup({ primary, secondary, onPrimaryClick, onSecondaryClick }) {
  return (
    <div className={styles.ctaGroup}>
      <Button
        variant={primary.variant}
        size="large"
        icon="sparkle"
        iconPosition="right"
        sparkle={true}
        onClick={() => onPrimaryClick(primary.action)}
      >
        {primary.label}
      </Button>
      <Button
        variant={secondary.variant}
        size="large"
        icon={secondary.icon}
        iconPosition="right"
        onClick={() => onSecondaryClick(secondary.action)}
      >
        {secondary.label}
      </Button>
    </div>
  );
}

export default HeroCTAGroup;
